import React, { SyntheticEvent } from "react";
import { StyledGlascLogo } from "./GlascLogo.styled";
import { Icon } from "../Icon/Icon";

export interface GlascLogoProps {
  className?: string;
  onClick?: (event: SyntheticEvent<HTMLElement>) => void;
}

export const GlascLogo: React.FC<GlascLogoProps> = ({ className, onClick }) => (
  <StyledGlascLogo className={className} onClick={onClick}>
    <Icon name="GlascLogo" />
  </StyledGlascLogo>
);
